/* src/app/components/select-language-modal/select-language-modal.component.scss */
.wrapper {
  width: 100%;
  background: #f2f2f2;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.031372549);
  height: 100%;
  overflow: auto;
  padding: 45px 15px 25px;
}
ion-img {
  width: 50px;
}
.title {
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #222222;
  margin-bottom: 25px;
}
.cross {
  position: absolute;
  top: 20px;
  right: 20px;
  height: 25px;
  width: 25px;
  padding: 3px;
}
ul {
  list-style-type: none;
  padding: 0px;
  padding-bottom: 50px;
}
li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
}
li .item-wrapper {
  padding: 12px 15px;
  background: #fff;
  margin-bottom: 5px;
  width: 100%;
  border: 1px solid #e8e8df;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 992px) {
  li .item-wrapper {
    padding-block: 9px;
  }
}
li .item-wrapper .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
li .item-wrapper .info_block p {
  font-family: AppFont;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
}
li .item-wrapper .info_block ion-img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}
li .item-wrapper .circle {
  width: 20px;
  height: 20px;
  content: " ";
  border: 1px solid rgba(112, 113, 115, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
li .item-wrapper .circle:has(.selected) {
  border: 2px solid var(--ion-color-primary);
}
li .item-wrapper .circle .cirle_inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 13.2px;
  height: 13.2px;
  content: " ";
  background: transparent;
  border-radius: 50%;
}
li .item-wrapper .circle .cirle_inner.selected {
  background: var(--ion-color-primary);
  border-radius: 50%;
  transition: ease-in-out 0.3s;
}
.line-border {
  padding: 0px 20px;
}
.line-border ion-icon {
  fill: white;
  width: 100%;
}
.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px 15px;
  display: flex;
  justify-content: center;
}
.footer-item ion-button {
  width: 100%;
}
/*# sourceMappingURL=select-language-modal.component.css.map */
